import * as React from 'react';
import { Tabs } from 'antd';
import { TabsProps } from 'antd/lib/tabs';
import { default as styled } from 'styled-components';
import { blueColor, middleBlackColor, transparentColor, lightBlackColor } from '@config/index';

export const StyledTabs = styled(Tabs)`
  &.ant-tabs {

    .ant-tabs-nav {
      margin-bottom: 0;

      &::before {
        margin-left:36px;
        margin-right:36px;
      }
    }

    .ant-tabs-content-holder {

      ::-webkit-scrollbar {
        display: none;
      }
    }
    .ant-tabs-nav-list {

      .ant-tabs-tab {
        padding: 16px 16px;
        line-height: 16px;
        font-size: 14px;
        color: ${middleBlackColor};
      }

      .ant-tabs-tab-disabled {
        color: lightgray !important;
      }

      .ant-tabs-ink-bar {
        height: 2px;
        box-sizing: border-box;
        border-left: 16px solid ${transparentColor};
        border-right: 16px solid ${transparentColor};
        background-color: ${blueColor};
      }

      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          font-weight: normal;
          color: ${blueColor};
        }
      }
    }
  }
`;

export class NiTabs extends React.Component<TabsProps, any> {
  static TabPane = Tabs.TabPane;
  render() {
    return <StyledTabs animated={true} {...this.props} />;
  }
}
